var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 314,
    viewBox: "0 0 512 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_15641)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.111 313.094C251.377 313.094 249.759 312.632 248.256 311.823L232.885 302.692C230.573 301.421 231.729 300.959 232.423 300.728C235.543 299.687 236.121 299.456 239.357 297.607C239.704 297.376 240.166 297.491 240.513 297.723L252.302 304.773C252.764 305.004 253.342 305.004 253.689 304.773L299.803 278.075C300.265 277.844 300.497 277.381 300.497 276.803V223.523C300.497 222.945 300.265 222.483 299.803 222.252L253.689 195.669C253.226 195.438 252.648 195.438 252.302 195.669L206.187 222.252C205.725 222.483 205.493 223.061 205.493 223.523V276.803C205.493 277.266 205.725 277.844 206.187 278.075L218.785 285.356C225.604 288.823 229.88 284.778 229.88 280.733V228.146C229.88 227.453 230.458 226.759 231.267 226.759H237.161C237.855 226.759 238.548 227.337 238.548 228.146V280.733C238.548 289.863 233.578 295.18 224.91 295.18C222.252 295.18 220.172 295.18 214.277 292.29L202.142 285.356C199.137 283.622 197.288 280.386 197.288 276.919V223.639C197.288 220.171 199.137 216.935 202.142 215.202L248.256 188.504C251.146 186.886 255.075 186.886 257.965 188.504L304.079 215.202C307.084 216.935 308.934 220.171 308.934 223.639V276.919C308.934 280.386 307.084 283.622 304.079 285.356L257.965 312.054C256.462 312.747 254.729 313.094 253.111 313.094ZM267.326 276.457C247.101 276.457 242.94 267.211 242.94 259.351C242.94 258.658 243.518 257.965 244.327 257.965H250.337C251.03 257.965 251.608 258.427 251.608 259.12C252.533 265.246 255.191 268.251 267.442 268.251C277.15 268.251 281.311 266.055 281.311 260.854C281.311 257.849 280.155 255.653 265.015 254.151C252.417 252.879 244.558 250.105 244.558 240.05C244.558 230.689 252.417 225.141 265.593 225.141C280.386 225.141 287.668 230.226 288.592 241.322C288.592 241.668 288.477 242.015 288.246 242.362C288.014 242.593 287.668 242.824 287.321 242.824H281.311C280.733 242.824 280.155 242.362 280.04 241.784C278.653 235.427 275.07 233.347 265.593 233.347C254.96 233.347 253.689 237.045 253.689 239.819C253.689 243.171 255.191 244.211 269.522 246.06C283.738 247.909 290.442 250.568 290.442 260.507C290.326 270.678 282.005 276.457 267.326 276.457Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.028 104.712C110.028 102.631 108.872 100.666 107.023 99.6262L58.019 71.4257C57.21 70.9634 56.2854 70.7323 55.3608 70.6167H54.8985C53.9739 70.6167 53.0493 70.9634 52.2402 71.4257L3.23617 99.6262C1.38696 100.666 0.231201 102.631 0.231201 104.712L0.346777 180.529C0.346777 181.569 0.924655 182.609 1.84926 183.072C2.77386 183.65 3.92962 183.65 4.73865 183.072L33.8637 166.429C35.7129 165.389 36.8687 163.424 36.8687 161.344V125.862C36.8687 123.781 38.0244 121.817 39.8736 120.777L52.2402 113.611C53.1648 113.033 54.205 112.802 55.2452 112.802C56.2854 112.802 57.3256 113.033 58.1346 113.611L70.5012 120.777C72.3504 121.817 73.5061 123.781 73.5061 125.862V161.344C73.5061 163.424 74.6619 165.389 76.5111 166.429L105.636 183.072C106.561 183.65 107.717 183.65 108.641 183.072C109.566 182.609 110.144 181.569 110.144 180.529L110.028 104.712Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.571 0.346727C344.646 -0.115576 343.491 -0.115576 342.682 0.346727C341.757 0.924605 341.179 1.84921 341.179 2.88939V78.0135C341.179 78.707 340.832 79.4005 340.139 79.8628C339.446 80.2095 338.752 80.2095 338.059 79.8628L325.808 72.8126C323.958 71.7725 321.763 71.7725 319.913 72.8126L270.909 101.129C269.06 102.169 267.904 104.134 267.904 106.214V162.73C267.904 164.811 269.06 166.776 270.909 167.816L319.913 196.132C321.763 197.172 323.958 197.172 325.808 196.132L374.812 167.816C376.661 166.776 377.817 164.811 377.817 162.73V21.8438C377.817 19.6479 376.661 17.6831 374.812 16.6429L345.571 0.346727ZM341.064 144.123C341.064 144.701 340.833 145.163 340.37 145.394L323.612 155.102C323.149 155.334 322.572 155.334 322.109 155.102L305.351 145.394C304.888 145.163 304.657 144.585 304.657 144.123V124.706C304.657 124.128 304.888 123.666 305.351 123.435L322.109 113.726C322.572 113.495 323.149 113.495 323.612 113.726L340.37 123.435C340.833 123.666 341.064 124.244 341.064 124.706V144.123Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M508.648 124.244C510.498 123.203 511.538 121.239 511.538 119.158V105.405C511.538 103.324 510.382 101.36 508.648 100.319L459.991 72.119C458.142 71.0788 455.946 71.0788 454.097 72.119L405.093 100.435C403.243 101.475 402.088 103.44 402.088 105.52V162.037C402.088 164.117 403.243 166.082 405.093 167.122L453.75 194.86C455.599 195.9 457.795 195.9 459.529 194.86L489.001 178.449C489.925 177.986 490.503 176.946 490.503 175.906C490.503 174.866 489.925 173.826 489.001 173.363L439.765 145.047C438.841 144.469 438.263 143.545 438.263 142.505V124.821C438.263 123.781 438.841 122.741 439.765 122.279L455.137 113.495C456.061 112.917 457.217 112.917 458.142 113.495L473.513 122.279C474.438 122.857 475.016 123.781 475.016 124.821V138.691C475.016 139.731 475.594 140.771 476.518 141.233C477.443 141.811 478.599 141.811 479.523 141.233L508.648 124.244Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M456.293 121.585C456.639 121.354 457.102 121.354 457.448 121.585L466.81 127.018C467.157 127.249 467.388 127.595 467.388 128.058V138.922C467.388 139.384 467.157 139.731 466.81 139.962L457.448 145.394C457.102 145.625 456.639 145.625 456.293 145.394L446.931 139.962C446.584 139.731 446.353 139.384 446.353 138.922V128.058C446.353 127.595 446.584 127.249 446.931 127.018L456.293 121.585Z",
    fill: "#539E43"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_15641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 71,
    width: 110,
    height: 125
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.971 72.3504C190.122 71.3103 187.926 71.3103 186.077 72.3504L137.419 100.435C135.57 101.476 134.53 103.44 134.53 105.521V161.806C134.53 163.886 135.686 165.851 137.419 166.891L186.077 194.976C187.926 196.016 190.122 196.016 191.971 194.976L240.628 166.891C242.478 165.851 243.518 163.886 243.518 161.806V105.521C243.518 103.44 242.362 101.476 240.628 100.435L191.971 72.3504Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_15641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.971 72.3504C190.122 71.3103 187.926 71.3103 186.077 72.3504L137.419 100.435C135.57 101.476 134.53 103.44 134.53 105.521V161.806C134.53 163.886 135.686 165.851 137.419 166.891L186.077 194.976C187.926 196.016 190.122 196.016 191.971 194.976L240.628 166.891C242.478 165.851 243.518 163.886 243.518 161.806V105.521C243.518 103.44 242.362 101.476 240.628 100.435L191.971 72.3504Z",
    fill: "url(#paint0_linear_2_15641)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.744 100.435L191.856 72.3503C191.393 72.1192 190.815 71.888 190.353 71.7725L135.57 165.62C136.032 166.198 136.61 166.66 137.188 167.007L186.077 195.092C187.464 195.901 189.082 196.132 190.584 195.67L242.015 101.591C241.669 101.129 241.206 100.782 240.744 100.435Z",
    fill: "url(#paint1_linear_2_15641)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.86 166.892C242.247 166.083 243.287 164.696 243.749 163.193L190.122 71.6574C188.735 71.4263 187.233 71.5418 185.961 72.3509L137.419 100.32L189.775 195.786C190.469 195.67 191.278 195.439 191.971 195.092L240.86 166.892Z",
    fill: "url(#paint2_linear_2_15641)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.86 166.892L192.087 194.977C191.393 195.323 190.7 195.554 189.891 195.67L190.815 197.404L244.905 166.083V165.389L243.518 163.078C243.287 164.696 242.247 166.083 240.86 166.892Z",
    fill: "url(#paint3_linear_2_15641)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.86 166.892L192.087 194.977C191.393 195.323 190.7 195.554 189.891 195.67L190.815 197.404L244.905 166.083V165.389L243.518 163.078C243.287 164.696 242.247 166.083 240.86 166.892Z",
    fill: "url(#paint4_linear_2_15641)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_15641",
    x1: 208.847,
    y1: 93.2865,
    x2: 155.512,
    y2: 177.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_15641",
    x1: 181.636,
    y1: 140.255,
    x2: 315.205,
    y2: 67.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_15641",
    x1: 132.753,
    y1: 133.665,
    x2: 245.343,
    y2: 133.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_15641",
    x1: 132.753,
    y1: 180.335,
    x2: 245.343,
    y2: 180.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_15641",
    x1: 261.746,
    y1: 90.626,
    x2: 233.223,
    y2: 240.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_15641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 314,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.8d2f42e327ecf3b9882d9eff987c610d.svg";
export { ForwardRef as ReactComponent };